import { Seo } from "@/components/seo";

function Dashboard() {
  return (
    <div>
      <Seo title="Dashboard" />

      <img
        src="/dashboard-placeholder.svg"
        alt="Dashboard"
        className="mx-auto mt-24 w-1/2"
      />
    </div>
  );
}

export default Dashboard;
